import { Link } from "react-router-dom";

export function TarjetasKoPage() {
  return (
    <div className="max-w-md mx-auto mt-12 text-center space-y-4">
      <h1 className="text-xl font-semibold text-[#2C2C2C]">No se pudo añadir la tarjeta</h1>
      <p className="text-sm text-gray-600">
        El banco no ha completado el registro. Puedes intentarlo de nuevo.
      </p>
      <Link
        to="/dashboard/tarjetas"
        className="inline-block rounded-lg bg-[#1A3AB8] px-4 py-2.5 text-sm font-medium text-white hover:bg-[#15308a]"
      >
        Volver a intentarlo
      </Link>
    </div>
  );
}
